<template>
  <div class="information">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="系统SKU统计" name="first">
        <COMparticulars :countryList="countryList" :listLogistics="listLogistics"></COMparticulars>
      </el-tab-pane>
      <!-- --------------------------库存批次 ----------------------- -->
      <el-tab-pane label="SKU别名统计" name="second">
        <CODstatistical :countryList="countryList" :listLogistics="listLogistics"></CODstatistical>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// 库存编辑
import COMparticulars from './CODcomponents/COMparticulars'
// 新增产品库存
import CODstatistical from './CODcomponents/CODstatistical'
import { ajaxPost, Baseurl } from '../../api/api/api'
export default {
  name: 'CODdecline',
  components: {
    COMparticulars,
    CODstatistical
  },
  data() {
    return {
      activeName: 'first',
      countryList: [],
      listLogistics: []
    }
  },
  mounted() {
    this.getCountry()
    this.getLogisticsList()
  },
  methods: {
    getLogisticsList() {
      const API = Baseurl + 'purchaseController/selectItemList'
      const paramsData = {
        itemCode: 'HYXUN0000007',
      }
      ajaxPost(API, paramsData).then((res) => {
        const {code, data} = res.data
        if (code === 200) {
          this.listLogistics = data
        }
      })
    },
    getCountry() {
      ajaxPost(
        Baseurl + 'logisticsConfigurationController/selectLogisticsCountryList'
      ).then((res) => {
        if (res.data.code === 200) {
          this.countryList = res.data.data
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ {
  .layout .layout-section ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #b71e1e;
  }

  .el-form-item__content {
    margin-left: 0px !important;
  }

  .el-divider--horizontal {
    margin: 15px 0;
  }
}

.table-body {
	width: 100%;
	border: 1px solid #eee;
	overflow: hidden;
}
.table-batch {
	width: 100%;
	overflow: hidden;
	height: 40px;
	line-height: 40px;
	padding-left: 25px;
}

.information {
  width: 98%;
  overflow: hidden;
  margin-bottom: 50px;
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 300px;
  height: 300px;
}

.padding {
  padding: 5px 0;
}

.line-height {
  line-height: 35px;
}

.page {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  z-index: 99;
}
</style>
